<template>
  <div class="container mx-auto">
    <el-dialog
      title="Nuevo tipo de nóminas"
      :visible.sync="showNewPaysheetType"
      width="900px"
    >
      <el-form
        :model="newPaysheetTypeForm"
        status-icon
        :rules="newPaysheetTypeFormRules"
        ref="newPaysheetType"
        @submit.native.prevent="
          submitNewPaysheetType('newPaysheetType', newPaysheetTypeForm)
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="6" class="flex flex-col justify-center">
            <el-form-item label="Nombre" prop="name">
              <el-input
                placeholder="Ingresa el nombre"
                v-model="newPaysheetTypeForm.name"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4" class="flex flex-col justify-center">
            <el-form-item label="Código" prop="code">
              <el-input
                placeholder="Ingresa el código"
                v-model="newPaysheetTypeForm.code"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10" class="flex flex-col justify-center">
            <el-form-item label="Descripción" prop="description">
              <el-input
                placeholder="Ingresa la descripción"
                v-model="newPaysheetTypeForm.description"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4" class="flex flex-col justify-center">
            <el-form-item label="Pagadera cada" prop="days">
              <el-select
                clearable
                size="small"
                v-model="newPaysheetTypeForm.days"
                placeholder="Seleccionar recurrencia"
              >
                <el-option label="15 días" value="15"></el-option>
                <el-option label="30 días" value="30"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showNewPaysheetType = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="Editar tipo de nóminas"
      :visible.sync="showEditPaysheetType"
      width="800px"
    >
      <el-form
        :model="editPaysheetTypeForm"
        status-icon
        :rules="editPaysheetTypeFormRules"
        ref="editPaysheetType"
        @submit.native.prevent="
          submitNewPaysheetType(
            'editPaysheetType',
            editPaysheetTypeForm,
            editPaysheetTypeForm.id
          )
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="7" class="flex flex-col justify-center">
                <el-form-item label="Nombre" prop="name">
                  <el-input
                    placeholder="Ingresa el nombre"
                    v-model="editPaysheetTypeForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" class="flex flex-col justify-center">
                <el-form-item label="Descripción" prop="description">
                  <el-input
                    placeholder="Ingresa la descripción"
                    v-model="editPaysheetTypeForm.description"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="5" class="flex flex-col justify-center">
                <el-form-item label="Pagadera cada" prop="days">
                  <el-select
                    clearable
                    size="small"
                    v-model="editPaysheetTypeForm.days"
                    placeholder="Seleccionar recurrencia"
                  >
                    <el-option label="15 días" value="15"></el-option>
                    <el-option label="30 días" value="30"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showEditPaysheetType = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="Nuevo tipo de contrato"
      :visible.sync="showNewContractType"
      width="350px"
    >
      <el-form
        :model="newContractTypeForm"
        status-icon
        :rules="newContractTypeFormRules"
        ref="newContractType"
        @submit.native.prevent="
          submitNewContractType('newContractType', newContractTypeForm)
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre del tipo de contrato" prop="name">
                  <el-input
                    placeholder="Nombre del tipo de contrato"
                    v-model="newContractTypeForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showNewContractType = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="Editar tipo de contrato"
      :visible.sync="showEditContractType"
      width="350px"
    >
      <el-form
        :model="editContractTypeForm"
        status-icon
        :rules="editContractTypeFormRules"
        ref="editContractType"
        @submit.native.prevent="
          submitNewContractType(
            'editContractType',
            editContractTypeForm,
            editContractTypeForm.id
          )
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre del tipo de contrato" prop="name">
                  <el-input
                    placeholder="Nombre del tipo de contrato"
                    v-model="editContractTypeForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showEditContractType = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-row :gutter="15" type="flex">
      <el-col :span="13">
        <el-row :gutter="15">
          <el-col :span="24" class="mb-5">
            <h3 class="text-l font-semibold">TIPOS DE NOMINAS</h3>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-alert
              :closable="false"
              title="Aquí se administran los diferentes tipos de contratos que se utilizan en el sistema."
              type="info"
              show-icon
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="8">
            <el-button
              type="primary"
              size="small"
              @click="openNewPaysheetTypeDialog"
              >Nuevo tipo de nómina</el-button
            >
          </el-col>
          <el-col :span="10">
            <el-input
              placeholder="Buscar"
              v-model="searchValue"
              size="small"
              suffix-icon="el-icon-search"
            ></el-input>
          </el-col>
        </el-row>
        <el-table :data="filteredPaysheetTypes" stripe size="mini">
          <el-table-column type="index" width="40" />
          <el-table-column prop="name" label="Nombre " min-width="80" />
          <el-table-column prop="code" label="Código " min-width="60" />
          <el-table-column
            prop="description"
            label="Descripción"
            min-width="220"
          />
          <el-table-column label="Pagadera cada" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.paysheetFrecuency.days }} días</span>
            </template>
          </el-table-column>
          <el-table-column label="Estado" min-width="100" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.active">
                <el-tag type="success" size="small">Activo</el-tag>
              </span>
              <span v-else>
                <el-tag type="warning" size="small">Inactivo</el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column width="60" align="center">
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <el-button
                  icon="el-icon-fa-ellipsis-v"
                  size="small"
                ></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="openEditPaysheetTypeDialog(scope.row)"
                  >
                    <i class="el-icon-fa-pencil"></i> Editar información
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="changePaysheetStatus(scope.row)"
                  >
                    <span v-if="scope.row.active">
                      <i class="el-icon-fa-times"></i> Desactivar
                    </span>
                    <span v-else>
                      <i class="el-icon-fa-check"></i> Activar
                    </span>
                    tipo de nómina
                  </el-dropdown-item>
                  <el-dropdown-item
                    :divided="true"
                    class="text-red-500 font-semibold"
                    @click.native="deletePaysheetType(scope.row)"
                  >
                    <i class="el-icon-fa-trash"></i> Eliminar tipo de nómina
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChange"
            :current-page.sync="page.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next"
            :total="rawContractTypes.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
      <el-col :span="11">
        <el-row :gutter="15">
          <el-col :span="24" class="mb-5">
            <h3 class="text-l font-semibold">TIPOS DE CONTRATOS</h3>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-alert
              :closable="false"
              title="Aquí se administran los diferentes tipos de contratos que se utilizan en el sistema."
              type="info"
              show-icon
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="8">
            <el-button
              type="primary"
              size="small"
              @click="openNewContractTypeDialog"
              >Nuevo tipo de contrato</el-button
            >
          </el-col>
          <el-col :span="10">
            <el-input
              placeholder="Buscar"
              v-model="searchValue"
              size="small"
              suffix-icon="el-icon-search"
            ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-table :data="filteredContractTypes" stripe size="mini">
              <el-table-column type="index" width="40" />
              <el-table-column
                prop="name"
                label="Nombre tipo de contrato"
                min-width="200"
              />
              <el-table-column label="Pais" min-width="100" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.country.name }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Estado" min-width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.active">
                    <el-tag type="success" size="small">Activo</el-tag>
                  </span>
                  <span v-else>
                    <el-tag type="warning" size="small">Inactivo</el-tag>
                  </span>
                </template>
              </el-table-column>
              <el-table-column width="60" align="center">
                <template slot-scope="scope">
                  <el-dropdown trigger="click">
                    <el-button
                      icon="el-icon-fa-ellipsis-v"
                      size="small"
                    ></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        @click.native="openEditContractTypeDialog(scope.row)"
                      >
                        <i class="el-icon-fa-pencil"></i> Editar información
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="changeStatus(scope.row)">
                        <span v-if="scope.row.active">
                          <i class="el-icon-fa-times"></i> Desactivar
                        </span>
                        <span v-else>
                          <i class="el-icon-fa-check"></i> Activar
                        </span>
                        tipo de contrato
                      </el-dropdown-item>
                      <el-dropdown-item
                        :divided="true"
                        class="text-red-500 font-semibold"
                        @click.native="deleteContractType(scope.row)"
                      >
                        <i class="el-icon-fa-trash"></i> Eliminar
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChange"
            :current-page.sync="page.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next"
            :total="rawContractTypes.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import * as V from "voca";

export default {
  name: "SettingsContracts",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{ 
          contractTypes { id name active country { name } }
          paysheetTypes { id name code description active paysheetFrecuency { days } }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => vm.setData(data.contractTypes, data.paysheetTypes));
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      rawContractTypes: [],
      rawPaysheetTypes: [],
      searchValue: "",
      page: {
        size: 15,
        number: 1,
      },
      pageP: {
        size: 15,
        number: 1,
      },
      showNewContractType: false,
      newContractTypeForm: {
        name: "",
      },
      newContractTypeFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
      },
      showEditContractType: false,
      editContractTypeForm: {
        name: "",
      },
      editContractTypeFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
      },
      showNewPaysheetType: false,
      newPaysheetTypeForm: {
        name: "",
        code: "",
        description: "",
        days: "",
      },
      newPaysheetTypeFormRules: {
        name: [
          {
            required: true,
            message: "Este campo es requerido.",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "Este campo es requerido.",
            trigger: "blur",
          },
          {
            min: 1,
            max: 2,
            message: "Mínimo 1 y máximo 2 letras",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "Este campo es requerido.",
            trigger: "blur",
          },
        ],
        days: [
          {
            required: true,
            message: "Este campo es requerido.",
            trigger: "change",
          },
        ],
      },
      showEditPaysheetType: false,
      editPaysheetTypeForm: {
        name: "",
        description: "",
        days: "",
      },
      editPaysheetTypeFormRules: {
        name: [
          {
            required: true,
            message: "Este campo es requerido.",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "Este campo es requerido.",
            trigger: "blur",
          },
        ],
        days: [
          {
            required: true,
            message: "Este campo es requerido.",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    setData(contract, paysheet) {
      this.rawContractTypes = contract;
      this.rawPaysheetTypes = paysheet;
    },
    handleSizeChange(val) {
      this.page.size = val;
    },
    changeStatus(contractType) {
      const action = contractType.active ? "desactivar" : "activar";
      const message = `¿Estás seguro que deseas ${action} este tipo de contrato?`;
      const saveText = `Si, ${V.titleCase(action)}`;
      this.$confirm(message, "Confirmación", {
        confirmButtonText: saveText,
        cancelButtonText: "Cancelar",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "Procesando...";
            axios
              .post("/", {
                query: `
                mutation { 
                  contractTypeUpdateStatus
                  ( where: { id: ${
                    contractType.id
                  } } active: ${!contractType.active} )
                  { id name active country { name } }
                }`,
              })
              .then((res) => {
                const { data, errors } = res.data;
                if (R.isNil(errors)) {
                  this.rawContractTypes = data.contractTypeUpdateStatus;
                }
                this.$notify({
                  title: R.isNil(errors) ? "Éxito" : "Error",
                  message: R.isNil(errors)
                    ? "Se ha cambiado el estado correctamente"
                    : errors[0].message,
                  type: R.isNil(errors) ? "success" : "error",
                  duration: 3500,
                });
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = saveText;
                done();
              });
          } else {
            done();
          }
        },
      });
    },
    deleteContractType({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar este tipo de contrato?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { contractTypeDelete( where: {id: ${id}} ) { id name active country { name } } }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawContractTypes = data.contractTypeDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado el banco correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    deletePaysheetType({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar este tipo de nómina?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { paysheetTypeDelete( where: {id: ${id}} ) { id name code description days active } }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawPaysheetTypes = data.paysheetTypeDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado el tipo de nomina correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    openNewContractTypeDialog() {
      const ref = this.$refs["newContractType"];
      if (!R.isNil(ref)) {
        ref.resetFields();
      }
      this.showNewContractType = true;
    },
    openEditContractTypeDialog({ id }) {
      axios
        .post("/", {
          query: `
          { 
            contractType(where: { id: ${id} }) { id name active country { name } }
          }
          `,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.editContractTypeForm = { ...data.contractType };
          }
          const ref = this.$refs["editContractType"];
          if (!R.isNil(ref)) {
            ref.resetFields();
          }
          this.showEditContractType = true;
        });
    },
    submitNewContractType(
      formName,
      { name, shortName },
      contractTypeId = false
    ) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        const action = contractTypeId ? "editar" : "crear";
        const mutation = contractTypeId
          ? `contractTypeEdit(data: { name: "${name}" } where: { id: ${contractTypeId} } )`
          : `contractTypeCreate(data: { name: "${name}" } )`;
        this.$confirm(
          `¿Estás seguro que deseas ${action} este banco?`,
          "Confirmación",
          {
            confirmButtonText: `Si, ${action}`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation { 
                      ${mutation}
                      { id name active country { name } }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      this.rawContractTypes = contractTypeId
                        ? data.contractTypeEdit
                        : data.contractTypeCreate;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? `Se ha creado el banco correctamente`
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showNewContractType = false;
                    this.showEditContractType = false;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, ${action}`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    changePaysheetStatus(paysheetType) {
      const action = paysheetType.active ? "desactivar" : "activar";
      const message = `¿Estás seguro que deseas ${action} este tipo de nómina?`;
      const saveText = `Si, ${V.titleCase(action)}`;
      this.$confirm(message, "Confirmación", {
        confirmButtonText: saveText,
        cancelButtonText: "Cancelar",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "Procesando...";
            axios
              .post("/", {
                query: `
                mutation { 
                  paysheetTypeUpdateStatus
                  ( where: { id: ${
                    paysheetType.id
                  } } active: ${!paysheetType.active} )
                  { id name code description days active }
                }`,
              })
              .then((res) => {
                const { data, errors } = res.data;
                if (R.isNil(errors)) {
                  this.rawPaysheetTypes = data.paysheetTypeUpdateStatus;
                }
                this.$notify({
                  title: R.isNil(errors) ? "Éxito" : "Error",
                  message: R.isNil(errors)
                    ? "Se ha cambiado el estado correctamente"
                    : errors[0].message,
                  type: R.isNil(errors) ? "success" : "error",
                  duration: 3500,
                });
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = saveText;
                done();
              });
          } else {
            done();
          }
        },
      });
    },
    openNewPaysheetTypeDialog() {
      const ref = this.$refs["newPaysheetType"];
      if (!R.isNil(ref)) {
        ref.resetFields();
      }
      this.showNewPaysheetType = true;
    },
    submitNewPaysheetType(
      formName,
      { name, code, description, days },
      paysheetTypeId = false
    ) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        const action = paysheetTypeId ? "editar" : "crear";
        const mutation = paysheetTypeId
          ? `paysheetTypeEdit(data: { 
                name: "${name}" 
                code: "${code}" 
                description: "${description}" 
                days: ${days}
            } where: { id: ${paysheetTypeId} } )`
          : `paysheetTypeCreate(data: { 
              name: "${name}" 
              code: "${code}" 
              description: "${description}" 
              days: ${days}
            } )`;
        this.$confirm(
          `¿Estás seguro que deseas ${action} este tipo de nómina?`,
          "Confirmación",
          {
            confirmButtonText: `Si, ${action}`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation { 
                      ${mutation}
                      { id name code description days active }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      this.rawPaysheetTypes = paysheetTypeId
                        ? data.paysheetTypeEdit
                        : data.paysheetTypeCreate;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? `Se ha creado el tipo de nómina correctamente`
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showNewPaysheetType = false;
                    this.showEditPaysheetType = false;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, ${action}`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    openEditPaysheetTypeDialog({ id }) {
      axios
        .post("/", {
          query: `{ paysheetType(where: { id: ${id} }) { id name description days } }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.editPaysheetTypeForm = { ...data.paysheetType };
          }
          const ref = this.$refs["editPaysheetType"];
          if (!R.isNil(ref)) {
            ref.resetFields();
          }
          this.showEditPaysheetType = true;
        });
    },
  },
  computed: {
    filteredContractTypes() {
      return this.rawContractTypes
        .filter((document) => {
          return document.name
            .toLowerCase()
            .includes(this.searchValue.toLowerCase());
        })
        .slice(
          this.page.number * this.page.size - this.page.size,
          this.page.size * this.page.number
        );
    },
    filteredPaysheetTypes() {
      return this.rawPaysheetTypes
        .filter((paysheet) => {
          return paysheet.name
            .toLowerCase()
            .includes(this.searchValue.toLowerCase());
        })
        .slice(
          this.pageP.number * this.pageP.size - this.pageP.size,
          this.pageP.size * this.pageP.number
        );
    },
  },
};
</script>
